export default {"src":"/_next/static/media/christmas_logo.8e917d18.svg","height":168,"width":170,"blurWidth":0,"blurHeight":0};